<template>
	<div>
		<div v-if="branches.length ==0">
			<layout>
				<pagetitle>Er zijn nog geen vestigingen aan deze account gekoppeld... neem contact op met de beheerder om dit alsnog te doen</pagetitle>
			</layout>
		</div>
		<div v-else-if="branches && branches.length>1">
			<branches></branches>
		</div>
		<div v-else-if="branches &&  branches.length==1">
			<branch :id="branches[0].id"></branch>
		</div>
		<div v-else>
			<layout>
				<pagetitle>Oeps, er ging iets mis...</pagetitle>
			</layout>
		</div>
	</div>
</template>

<script>
import layout 	from '../layout/layout.vue'
import branches from './branches.vue'
import branch 	from './branch.vue'

export default {

	name: 'dashboard',
	
	components:{
		layout,
		branches,
		branch,
	},

	data () {
		return {
			branches : this.$store.state.user.branches,
		}
	}
	,
	mounted() {
		
	},
}
</script>

<style lang="css" scoped>
</style>